import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { money, fmtTime } from "@/lib/format";
import PageHeader from "@/components/PageHeader";
import { Badge } from "@/components/ui/badge";
import { ExternalLink } from "lucide-react";

export default function Tokens() {
  const { restaurant } = useAuth();
  const { data: orders = [] } = useQuery({
    queryKey: ["tokens"],
    queryFn: async () => (await api.get("/tokens")).data,
    refetchInterval: 4000,
  });
  const { data: settings } = useQuery({ queryKey: ["settings"], queryFn: async () => (await api.get("/settings")).data });
  const sym = settings?.currency_symbol || "₹";

  return (
    <div className="h-full overflow-y-auto p-6 lg:p-8" data-testid="tokens-page">
      <PageHeader title="Token Management" subtitle={`Takeaway & kiosk queue — TV board at /r/${restaurant?.slug || "your-slug"}/tokens`}>
        <a href={restaurant?.slug ? `/r/${restaurant.slug}/tokens` : "/tokens"} target="_blank" rel="noreferrer" className="text-sm text-[var(--kul-primary)] flex items-center gap-1">
          <ExternalLink className="w-4 h-4" /> Open TV display
        </a>
      </PageHeader>
      <div className="space-y-2 max-w-3xl">
        {orders.map((o) => (
          <div key={o.id} className="kul-card p-4 flex items-center justify-between">
            <div>
              <div className="font-display text-2xl font-800">{o.token_number}</div>
              <div className="text-xs text-neutral-500">{o.order_number} · {o.customer_name || "Guest"} · {fmtTime(o.created_at)}</div>
            </div>
            <div className="text-right">
              <Badge className="capitalize">{o.kitchen_status || o.status}</Badge>
              <div className="text-sm mt-1">{money(o.total, sym)}</div>
            </div>
          </div>
        ))}
        {!orders.length && <div className="text-neutral-400 py-16 text-center">No tokens today. Kiosk and takeaway orders issue tokens automatically.</div>}
      </div>
    </div>
  );
}
